import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import "./styles.scss";
import BackArrow from "../../../../Assets/Svg/Auth/BackArrow.svg";
import MainLayout from "../../../../Layouts/Main";
import ProgressBar from "../../../../Components/Progressbar";
import { MdOutlineRadioButtonChecked } from "react-icons/md";
import PDFIcom from "../../../../Assets/Images/pdfImg.png";
import {
  getPreassessmentRecommendation_USER,
  getRecommendationPercentageCompleted,
  markRecommendationAsRead,
  preAsessmentCategoryListRequest_USER,
} from "../../../../Redux/Slices/User/userSlice";
import Loader from "Components/Loader";
import Button from "Components/Button";


const ConfirmMarkAsReadModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="instructions-modal">
      <div className="instructions-content">
        <h2>Notice</h2>
        <p>
          Once you mark recommendations as read, the action is recorded.< b> The action cannot be undone. </b> <b> This modal will only appear once.</b>
        </p>
        <div className="instructions-buttons">
          <Button
            title="Back"
            onClick={onClose}
            buttonStyle={{ height: '44px' }}
            titleStyle={{ fontSize: '20px', fontWeight: '600' }}
          />
          <Button
            title="Continue"
            onClick={onClose}
            buttonStyle={{ height: '44px' }}
            titleStyle={{ fontSize: '20px', fontWeight: '600' }}
          />
        </div>
      </div>
    </div>
  );
};

function PreAssessmentRecommendation() {
  const [activeTab, setActiveTab] = useState(0);
  const [tabTitles, setTabTitles] = useState([]);
  const [subTitles, setSubTitles] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [progress, setProgress] = useState(0);
  const [loadingSubCategories, setLoadingSubCategories] = useState([]);
  const [completedPercentage, setCompletedPercentage] = useState(0);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userDetails = JSON.parse(localStorage?.getItem("userDetails"));
  const { AssessmentId } = useParams();

  useEffect(() => {
    getAllModules();
    getCompletedPercentage();
    setShowConfirmModal(true);
  }, []);

  const getAllModules = () => {
    dispatch(
      preAsessmentCategoryListRequest_USER({
        callBack: (data) => {
          const modules = data?.data_list;
          if (modules?.length > 0) {
            setTabTitles(modules);
            setActiveTab(0);
            const firstCategoryId = modules[0]?.category_id;
            setCategoryId(firstCategoryId);
            updateProgress(0, modules.length); // Set initial progress for the first tab
            getAllSubModules(firstCategoryId);
          }
        },
      })
    );
  };

  const getAllSubModules = (catId) => {
    if (catId && userDetails?.user_id) {
      dispatch(
        getPreassessmentRecommendation_USER({
          assessment_id: Number(AssessmentId),
          user_id: Number(userDetails.user_id),
          category_id: Number(catId),
          callBack: (data) => {
            if (data?.status === 200 && Array.isArray(data?.data)) {
              setSubTitles(data.data);
            } else {
              setSubTitles([]);
            }
          },
        })
      );
    }
  };

  const handleTabClick = (index, catId) => {
    setActiveTab(index);
    setCategoryId(catId);
    setSubTitles([]);
    updateProgress(index, tabTitles.length); // Update progress based on the selected tab
    getAllSubModules(catId);
  };

  const updateProgress = (currentIndex, totalTabs) => {
    const newProgress = ((currentIndex + 1) / totalTabs) * 100;
    setProgress(newProgress);
  };

  const getCompletedPercentage = () => {
    dispatch(
      getRecommendationPercentageCompleted({
        assessment_id: Number(AssessmentId),
        callBack: (percentage) => {
          setCompletedPercentage(Number(percentage?.percentage) || 0);
        }
      })
    );
  };


  const handleMarkAsRead = (subCategoryId) => {
    setLoadingSubCategories((prev) => [...prev, subCategoryId]);

    dispatch(
      markRecommendationAsRead({
        data: {
          assessment_id: Number(AssessmentId),
          sub_category_id: Number(subCategoryId),
        },
        callBack: () => {
          setSubTitles((prev) =>
            prev?.map((it) =>
              it.sub_category_id === subCategoryId
                ? { ...it, is_read: true }
                : it
            )
          );
          setLoadingSubCategories((prev) =>
            prev.filter((id) => id !== subCategoryId)
          );
          getCompletedPercentage();
        },
        errorCallback: () => {
          setLoadingSubCategories((prev) =>
            prev.filter((id) => id !== subCategoryId)
          );
        },
      })
    );
  };



  const isPDF = (url) => {
    return url?.toLowerCase().endsWith(".pdf");
  };


  return (
    <MainLayout>
      <div className="recommendations">
        <div className="Header-recommendations">
          <div className="d-flex align-items-center">
            <img
              src={BackArrow}
              alt="backarrow"
              width="25px"
              height="23px"
              onClick={() => navigate(-1)}
              style={{
                marginLeft: "-10px",
                cursor: "pointer",
              }}
            />
            <h2 className="journey-title ms-2">Recommendations</h2>
          </div>
        </div>
        <br />
        <div className="header">
          <h1 className="left-title">Recommendation Tracker</h1>
        </div>
        <ProgressBar completedPercentage={progress} />
        <div className="d-flex align-items-center justify-content-between mb-2 mt-4">
          <h5 className="completed-text">
            Completed Recommendations: {completedPercentage}%
          </h5>
        </div>

        <ProgressBar
          completedPercentage={completedPercentage}
          fillColor="#1f2155"
        />

        <div className="recommendation-spacer-30px" />
        <div className="tabs-recommendation">
          {tabTitles?.map((tab, index) => (
            <div
              key={index}
              className={`tab-item ${activeTab === index ? "active" : ""}`}
              onClick={() => handleTabClick(index, tab?.category_id)}
            >
              {tab?.category_name}
            </div>
          ))}
        </div>
        <div className="content">
          {subTitles?.length > 0 ? (
            subTitles?.map((item, index) => (
              <div key={item.sub_category_id} className="item-container">
                <h2 className="item-header d-flex align-items-center gap-3">
                  {loadingSubCategories.includes(item.sub_category_id) ? (
                    <Loader />
                  ) : (
                    <input
                      type="checkbox"
                      checked={item.is_read}
                      disabled={item.is_read}
                      onChange={() => handleMarkAsRead(item.sub_category_id)}
                    />
                  )}
                  {item?.sub_category_name}</h2>
                <div className="item-sections">
                  {item?.messages
                    ?.filter((section) => section.message?.trim())
                    .map((section, index) => (
                      <div key={index} className="section">
                        <div>
                          {/* <div className="">
                            <MdOutlineRadioButtonChecked color="#1f2155" size={20} />
                          </div> */}
                          <div className="section-content">
                            {section.image_url?.length > 0 && (
                              <div className="media-container">
                                {section.image_url.map((url, i) =>
                                  isPDF(url) ? (
                                    <div key={i} className="pdf-container">
                                      <a href={url} target="_blank" rel="noopener noreferrer">
                                        <img
                                          src={PDFIcom}
                                          alt="PDF"
                                          width="75px"
                                          height="auto"
                                        />
                                        <p>Open PDF</p>
                                      </a>
                                    </div>
                                  ) : (
                                    <img
                                      key={i}
                                      src={url}
                                      alt="recommendation"
                                      className="recommendation-image"
                                    />
                                  )
                                )}
                              </div>
                            )}
                            <span className="message" dangerouslySetInnerHTML={{ __html: section.message }}></span>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            ))
          ) : (
            <div className="noRecommendationLabel">No Recommendations</div>
          )}
        </div>
      </div>

      <ConfirmMarkAsReadModal
        isOpen={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
      />
    </MainLayout>
  );
}

export default PreAssessmentRecommendation;
